pnk-tabs {
  /* Component styles go here */
}
